var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c("b-row", { staticClass: "topInfoRow" }, [
        _c("div", { staticClass: "card noBoxShadow col6-left" }, [
          !_vm.areThereFilters
            ? _c("h4", { staticClass: "marginB-5" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.usersInSystem ? _vm.usersInSystem.toLocaleString() : 0
                    ) +
                    "\n      "
                )
              ])
            : _c("h4", { staticClass: "marginB-5" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.totalRows) +
                    " of " +
                    _vm._s(
                      _vm.usersInSystem ? _vm.usersInSystem.toLocaleString() : 0
                    ) +
                    "\n      "
                )
              ]),
          _vm._v(" "),
          _c("p", { staticClass: "marginB-5" }, [_vm._v("User Records")]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.activeUserLength) + " ACTIVE USERS")]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "b-button",
                {
                  staticClass: "smallBtnLeft",
                  attrs: { variant: "primary" },
                  on: { click: _vm.addUser }
                },
                [_vm._v("Add New User")]
              ),
              _vm._v(" "),
              _vm.isSuperAdmin && !_vm.isDeactivateUsersModeOn
                ? _c(
                    "b-button",
                    {
                      staticClass: "smallBtnRight",
                      attrs: { variant: "primary" },
                      on: { click: _vm.toggleDeactiveUsersModeOn }
                    },
                    [_vm._v("\n          Deactivate Users\n        ")]
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card noBoxShadow col6-right" },
          [
            _c("div", [
              _c("h4", { staticClass: "marginB-5" }, [_vm._v("Search")]),
              _vm._v(" "),
              _c("p", [_vm._v("By Name, Email or Primary Organization")])
            ]),
            _vm._v(" "),
            _c(
              "b-input-group",
              { staticClass: "searchClearInput" },
              [
                _c("b-form-input", {
                  attrs: { placeholder: "Type to Search" },
                  on: { input: _vm.handleFilterChange },
                  model: {
                    value: _vm.filter.nameText,
                    callback: function($$v) {
                      _vm.$set(_vm.filter, "nameText", $$v)
                    },
                    expression: "filter.nameText"
                  }
                }),
                _vm._v(" "),
                _c(
                  "b-input-group-addon",
                  [
                    _c(
                      "b-btn",
                      {
                        attrs: { disabled: !_vm.filter.nameText },
                        on: { click: _vm.clearFilter }
                      },
                      [_vm._v("Clear")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "b-btn",
            {
              directives: [
                {
                  name: "b-toggle",
                  rawName: "v-b-toggle.collapse1",
                  modifiers: { collapse1: true }
                }
              ],
              staticClass: "filterBtn bgDarkBlue",
              attrs: { variant: "primary" }
            },
            [
              _vm._v("Filters"),
              _c("img", {
                staticStyle: { "margin-left": "14px" },
                attrs: {
                  src: require("../../../../static/img/filterIcon.png"),
                  width: "17px",
                  height: "11px"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "b-collapse",
            {
              staticClass: "filterCollapse marginB-62",
              attrs: { id: "collapse1" }
            },
            [
              _c(
                "b-card",
                [
                  _c(
                    "div",
                    { staticClass: "div1" },
                    [
                      _c("span", [_vm._v("Filters")]),
                      _vm._v(" "),
                      _c(
                        "b-btn",
                        {
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.resetFilters.apply(null, arguments)
                            }
                          }
                        },
                        [_vm._v("Clear Filters")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "div2" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "field",
                          attrs: { label: "CSE-IT Trained" }
                        },
                        [
                          _c(
                            "b-form-select",
                            {
                              staticClass: "greySelect",
                              model: {
                                value: _vm.isCseitTrained,
                                callback: function($$v) {
                                  _vm.isCseitTrained = $$v
                                },
                                expression: "isCseitTrained"
                              }
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: { slot: "first" },
                                  domProps: { value: null },
                                  slot: "first"
                                },
                                [_vm._v("Choose...")]
                              ),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "true" } }, [
                                _vm._v("Yes")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "false" } }, [
                                _vm._v("No")
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        { staticClass: "field", attrs: { label: "Is Active" } },
                        [
                          _c(
                            "b-form-select",
                            {
                              staticClass: "greySelect",
                              model: {
                                value: _vm.isActive,
                                callback: function($$v) {
                                  _vm.isActive = $$v
                                },
                                expression: "isActive"
                              }
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: { slot: "first" },
                                  domProps: { value: null },
                                  slot: "first"
                                },
                                [_vm._v("Choose...")]
                              ),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "true" } }, [
                                _vm._v("true")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "false" } }, [
                                _vm._v("false")
                              ]),
                              _vm._v(" "),
                              _c(
                                "option",
                                { attrs: { value: "deactivated" } },
                                [_vm._v("deactivated")]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        { staticClass: "field", attrs: { label: "Role" } },
                        [
                          _c(
                            "b-form-select",
                            {
                              staticClass: "greySelect",
                              model: {
                                value: _vm.userRole,
                                callback: function($$v) {
                                  _vm.userRole = $$v
                                },
                                expression: "userRole"
                              }
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: { slot: "first" },
                                  domProps: { value: null },
                                  slot: "first"
                                },
                                [_vm._v("Choose...")]
                              ),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "user" } }, [
                                _vm._v("User")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "manager" } }, [
                                _vm._v("Manager")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "admin" } }, [
                                _vm._v("Admin")
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        { staticClass: "field", attrs: { label: "State" } },
                        [
                          _c(
                            "b-form-select",
                            {
                              staticClass: "greySelect",
                              attrs: { options: _vm.stateOptions },
                              model: {
                                value: _vm.userState,
                                callback: function($$v) {
                                  _vm.userState = $$v
                                },
                                expression: "userState"
                              }
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: { slot: "first" },
                                  domProps: { value: null },
                                  slot: "first"
                                },
                                [_vm._v("Choose...")]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          staticClass: "field",
                          attrs: { label: "Primary Organization" }
                        },
                        [
                          _c(
                            "b-form-select",
                            {
                              staticClass: "greySelect",
                              attrs: { options: _vm.organizationOptions },
                              model: {
                                value: _vm.primaryOrg,
                                callback: function($$v) {
                                  _vm.primaryOrg = $$v
                                },
                                expression: "primaryOrg"
                              }
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: { slot: "first" },
                                  domProps: { value: null },
                                  slot: "first"
                                },
                                [_vm._v("Choose...")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { type: "submit", variant: "primary" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.updateSearchResults.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("\n          Save\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "h2",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.finishedLoading,
                  expression: "!finishedLoading"
                }
              ],
              staticClass: "u-padding-bottom-20"
            },
            [_vm._v("Loading, please wait ...")]
          ),
          _vm._v(" "),
          _c("pulse-loader", {
            attrs: {
              loading: !_vm.finishedLoading,
              color: _vm.spinnerColor,
              size: _vm.spinnerSize
            }
          }),
          _vm._v(" "),
          _c("b-table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.finishedLoading,
                expression: "finishedLoading"
              }
            ],
            key: _vm.tableKey,
            ref: "usersTable",
            attrs: {
              filter: _vm.filter,
              "filter-function": _vm.searchFilter,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              "sort-direction": _vm.sortDirection,
              hover: true,
              striped: true,
              bordered: false,
              small: true,
              fixed: true,
              responsive: "sm",
              items: _vm.tableItems,
              fields: _vm.tableFields,
              "per-page": 20,
              "current-page": _vm.currentPage
            },
            on: {
              "update:sortBy": function($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function($event) {
                _vm.sortDesc = $event
              },
              filtered: _vm.onFiltered
            },
            scopedSlots: _vm._u([
              {
                key: "isSelectedToDeactivate",
                fn: function(data) {
                  return _c(
                    "div",
                    {},
                    [
                      _c("b-form-checkbox", {
                        staticClass: "users-table__checkbox",
                        attrs: { disabled: data.item.isRemoved },
                        model: {
                          value: data.item.isSelectedToDeactivate,
                          callback: function($$v) {
                            _vm.$set(data.item, "isSelectedToDeactivate", $$v)
                          },
                          expression: "data.item.isSelectedToDeactivate"
                        }
                      })
                    ],
                    1
                  )
                }
              },
              {
                key: "fullName",
                fn: function(data) {
                  return _c(
                    "div",
                    {},
                    [
                      _c(
                        "b-link",
                        {
                          on: {
                            click: function($event) {
                              return _vm.goUser(data.item.id)
                            }
                          }
                        },
                        [_c("span", {}, [_vm._v(_vm._s(data.value))])]
                      )
                    ],
                    1
                  )
                }
              },
              {
                key: "primaryOrganization",
                fn: function(data) {
                  return _c("div", {}, [
                    _c("span", [
                      _vm._v(
                        _vm._s(data.item.isRemoved ? "" : data.value.title)
                      )
                    ])
                  ])
                }
              },
              {
                key: "role",
                fn: function(data) {
                  return _c("div", {}, [
                    _c("span", {}, [
                      _vm._v(_vm._s(_vm.getUserRole(data.item, true)))
                    ])
                  ])
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "users-table__footer" },
            [
              _c("b-pagination", {
                attrs: {
                  "total-rows": _vm.getRowCount(_vm.tableItems),
                  "prev-text": "Prev",
                  "next-text": "Next",
                  "current-page": _vm.currentPage
                },
                model: {
                  value: _vm.currentPage,
                  callback: function($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage"
                }
              }),
              _vm._v(" "),
              _vm.isSuperAdmin && _vm.isDeactivateUsersModeOn
                ? _c(
                    "div",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "secondary" },
                          on: { click: _vm.cancelDeactivateUserSelection }
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-2",
                          attrs: {
                            variant: "danger",
                            disabled: !_vm.usersToDeactivate.length
                          },
                          on: { click: _vm.showDeactivateUsersModal }
                        },
                        [_vm._v("\n          Submit\n        ")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            title: "Deactivate Users",
            size: "lg",
            "ok-title": "Confirm Deactivation",
            "cancel-title": "Cancel",
            "header-bg-variant": "success",
            "header-text-variant": "light",
            "ok-variant": "success",
            "no-close-on-backdrop": ""
          },
          on: { ok: _vm.deactivateUsers },
          scopedSlots: _vm._u([
            {
              key: "modal-header-close",
              fn: function() {
                return [_c("h4", [_vm._v("X")])]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.isDeactivateUsersModalVisible,
            callback: function($$v) {
              _vm.isDeactivateUsersModalVisible = $$v
            },
            expression: "isDeactivateUsersModalVisible"
          }
        },
        [
          _vm._v(" "),
          _c("p", [
            _vm._v("\n      The following users will be deactivated\n    ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "user-list" },
            _vm._l(_vm.usersToDeactivate, function(user) {
              return _c("div", { staticClass: "user-list__item" }, [
                _c("div", [
                  _vm._v("\n          " + _vm._s(user.fullName) + "\n        ")
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n          " + _vm._s(user.emailAddress) + "\n        "
                  )
                ])
              ])
            }),
            0
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e5c5d060", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5c5d060","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/Users.vue
// module id = 1816
// module chunks = 0